import { Link } from "react-router-dom";
import type { Download, CourseDocument } from "@/src/lib/content";

export function DocumentContent({ html, className = "" }: { html: string; className?: string }) {
  return <div className={`document-content ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
}

export function RegulatoryBanner({ compact = false }: { compact?: boolean }) {
  return (
    <aside className={`regulatory-banner ${compact ? "compact" : ""}`} aria-label="Regulatory currency note">
      <span className="status-dot" aria-hidden="true" />
      <div><strong>Regulatory content is time-bound.</strong> The Digital Omnibus amendment was formally adopted on 29 June 2026. Verify its Official Journal citation, entry into force, and later changes before teaching.</div>
      <Link to="/course/regulatory">Read the course timeline</Link>
    </aside>
  );
}

export function DownloadRow({ files, label = "Download materials" }: { files: Download[]; label?: string }) {
  if (!files.length) return null;
  return (
    <section className="download-section" aria-labelledby={`downloads-${label.replace(/\W/g, "-")}`}>
      <h2 id={`downloads-${label.replace(/\W/g, "-")}`}>{label}</h2>
      <div className="download-grid">
        {files.map((file) => <a className="download-card" href={file.href} download key={`${file.href}-${file.title}`}><span className="file-type">{file.type}</span><span>{file.title}</span><small>Download file</small></a>)}
      </div>
    </section>
  );
}

export function MaterialDocuments({ docs, basePath }: { docs: CourseDocument[]; basePath: string }) {
  if (!docs.length) return null;
  return (
    <section className="materials-stack" aria-labelledby="student-materials-title">
      <div className="section-heading">
        <p className="eyebrow">Use in practice</p>
        <h2 id="student-materials-title">Student materials</h2>
        <p className="material-stack-intro">Read each item here, or open its focused full-page view to print or save a PDF.</p>
      </div>
      {docs.map((doc, index) => (
        <details className="material-panel" key={doc.id}>
          <summary><span>{String(index + 1).padStart(2, "0")}</span><span className="material-summary-copy"><small>{doc.kind}</small><strong>{doc.title}</strong></span></summary>
          <div className="material-inner">
            <p className="material-summary">{doc.summary}</p>
            <DocumentContent html={doc.html} />
            <div className="material-actions"><Link className="button secondary" to={`${basePath}/material/${doc.id}`}>Open full-page material</Link><small>Use the full-page view to print or save a PDF.</small></div>
          </div>
        </details>
      ))}
    </section>
  );
}
